import React, {useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { ToastContainer, toast } from 'react-toastify';
import LoadingButton from '@mui/lab/LoadingButton';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios"
import darkTheme from '../../src/theme';
import { useRouter } from 'next/router';


export default function Form() {

  const [loading, setLoading] = useState(false);  
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [venue, setVenue] = useState('');
  const Router = useRouter();

  const handleChangeName = (event) => {
    setName(event.target.value);
  };

  const handleChangeEmail = (event) => {
    setEmail(event.target.value);
  };

  const handleChangeMobile = (event) => {
    setMobile(event.target.value);
  };

  const handleChangeVenue = (event) => {
    setVenue(event.target.value);
  };

  const onSubmitContact = (event) => {     
    // alert('yeah')  
    event.preventDefault();   
    setLoading(true)
    const data = {
      mobile: mobile,
      email: email,
      name: name,          
      venue: venue        
    };    
    if (!data.name) {
      toast.error(`Please Enter Name`, {
        position: toast.POSITION.TOP_CENTER
      });
      setLoading(false)
    } else if (!data.email) {
      toast.error(`Please Enter Valid Email ID`, {
        position: toast.POSITION.TOP_CENTER
      });
      setLoading(false) 
    } else if (!data.mobile) {
      toast.error(`Please Enter Valid Mobile Number`, {
        position: toast.POSITION.TOP_CENTER
      });
        setLoading(false)
    }else if (!data.venue) {
      toast.error(`Please Enter Venue Name`, {
        position: toast.POSITION.TOP_CENTER
      });
      setLoading(false)   
    } else { 
      if (data.mobile.length != 10 ) {        
        toast.error(`Please Enter Valid Mobile Number`, {
          position: toast.POSITION.TOP_CENTER
        });
        setLoading(false) 
      } else if (data.email.indexOf('@') <=0 || data.email.indexOf('.') <=0) {
      toast.error(`Please Enter Valid Email ID`, {
        position: toast.POSITION.TOP_CENTER
      });
      setLoading(false)     
      } else {          
        setLoading(true);
        axios.post(`/api/auth/backstage`,
          { data: data },
          {
          headers: {
            'x-auth-token': process.env.JWT_TOKEN
          }
        }).then((response) => {
          if (response.status == 200) {
            setLoading(false)
            if (response.data.status == 0) {
              toast.error(`Something Went Wrong`, {
                position: toast.POSITION.TOP_CENTER
              });                                                
            } else {
              
              if(email){
                axios.post(`${process.env.BACKSTAGE_APP_SERVER}/api/messaging/sendEmail/contactConfirmation`,
                  {
                    "toAddress": email,
                    "toName": name ? name : 'User'
                  },
                  {
                    headers:{
                      'x-auth-token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE2OTI4NjYyNDF9.slCFZbe5TOJr2rSjRSQWevopQnyXhnqB1EFcNOfFl28'
                    }
                  }
                ).then((response)=>{
                  console.log(response);
                })
              }
              toast.success(`Form has been Submitted Successfully!`, {
                position: toast.POSITION.TOP_CENTER
              });
              setName('')                 
              setEmail('')                 
              setMobile('')              
              setVenue('')  
              Router.push('backstage/thanks')
            }
          }
        })
        .catch(err => {
          console.log(err);
        })
      }
    }
  }
   
  return (
    <Box component="div">  
      <TextField
        variant="outlined"
        fullWidth
        id="name"
        label="Full Name"
        type="text"
        sx={{ mb: darkTheme.spacing(3), background:`${darkTheme.palette.background.default} !imrpotant` }}
        onChange={handleChangeName}
        value={name}    
        color="light"                   
      />  

      

      <TextField
        variant="outlined"
        fullWidth
        id="Email"
        label="Email"
        type="email"
        sx={{ mb: darkTheme.spacing(3), background:`${darkTheme.palette.background.default} !imrpotant` }}
        onChange={handleChangeEmail}
        value={email} 
        color="light"                      
      />  

      <TextField
        variant="outlined"
        fullWidth
        id="number"
        label="Mobile"
        type="number"
        sx={{ mb: darkTheme.spacing(3), background:`${darkTheme.palette.background.default} !imrpotant` }}
        onChange={handleChangeMobile}
        value={mobile}
        color="light"
        />

      <TextField
        variant="outlined"
        fullWidth
        id="venue"
        label="Venue Name"
        type="text"
        color="light"
        sx={{ mb: darkTheme.spacing(3), background:`${darkTheme.palette.background.default} !imrpotant` }}
        onChange={handleChangeVenue}
        value={venue}                       
      />  

        <Typography component="div" sx={{mt: darkTheme.spacing(1), textAlign:'center' }}>
          <LoadingButton          
            variant="contained"
            className="themeBtn"
            onClick={onSubmitContact}          
            loading={loading}  
            size="large"   
            type="submit"   
            loadingPosition="end"
            color="primary"
            sx={{minWidth:200, py:2}}
            >
            Submit
        </LoadingButton> 
        </Typography>
        <ToastContainer position={toast.POSITION.BOTTOM_LEFT} />
      </Box>
  );
}